import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Form,
  FormGroup,
  Badge,
  Progress,
} from "reactstrap";

import axios from "axios";

import { useState, useEffect } from "react";
import { API_TIMEOUT } from "utils";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";

import { formatDate } from "utils/func";
import { toProperCase } from "utils/func";
import Success from "../assets/img/success.png";
import Phone from "../assets/img/phone-call.png";

import { logApp } from "utils/func";
import { refreshToken } from "utils/func";
import { API_DONOR_DARAH } from "utils";

function ListDonatur() {
  const domain = "https://satudata.rotendaokab.go.id/uploads/";
  const [tabelRequest, setTabelRequest] = useState([]);

  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    nama: "",
    bloodTypes: "",
    desa: "",
    noHp: "",
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const history = useHistory();

  const [id_unit, setId_Unit] = useState("");
  const [tanggal, setTanggal] = useState("");

  const [jumlah, setJumlah] = useState(0);

  const [saveLoading, setSaveLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const [listGolda, setListGolda] = useState([]);
  const [golda, setGolda] = useState("all");
  const [tahun, setTahun] = useState(new Date().getFullYear().toString());
  const [listData, setListData] = useState([]);
  const [listDesa, setListDesa] = useState([]);
  const [filteredRequest, setFilteredRequest] = useState([]);
  const [modalWhatsAppOpen, setModalWhatsAppOpen] = useState(false);
  const [selectedDonor, setSelectedDonor] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    // Jika data yang disimpan di localStorage adalah dalam format JSON, Anda perlu menguraikannya menjadi objek
    getListGolda();
    getListDesa();
    if (!currentUser) {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        logApp(user.uid, "Donatur");
        setCurrentUser(user);
      } else {
        history.push("/login");
      }
    }
    //ambilListDokumen();
    // refreshToken(history, setAccessToken);
  }, []);

  useEffect(() => {
    if (currentUser) {
      ambilRequest(currentUser.uid);
    }
  }, [currentUser]);

  // Filter data berdasarkan golongan darah, tahun, dan pencarian
  useEffect(() => {
    if (listData.length > 0) {
      let filtered = [...listData];

      // Filter berdasarkan golongan darah
      if (golda !== "all") {
        filtered = filtered.filter((item) => item.bloodTypes === golda);
      }

      // Filter berdasarkan tahun (jika ada field tanggal atau createdAt)
      if (tahun) {
        filtered = filtered.filter((item) => {
          // Jika ada field createdAt atau tanggal, filter berdasarkan tahun
          if (item.createdAt) {
            const itemYear = new Date(item.createdAt).getFullYear().toString();
            return itemYear === tahun;
          }
          // Jika tidak ada field tanggal, tampilkan semua (karena data donatur mungkin tidak punya tanggal)
          return true;
        });
      }

      // Filter berdasarkan pencarian (nama atau nomor HP)
      if (searchQuery && searchQuery.trim() !== "") {
        const query = searchQuery.toLowerCase().trim();
        filtered = filtered.filter((item) => {
          const nama = (item.nama || "").toLowerCase();
          const noHp = (item.noHp || "").toLowerCase();
          return nama.includes(query) || noHp.includes(query);
        });
      }

      setTabelRequest(filtered);
      setFilteredRequest(filtered);
    } else {
      setTabelRequest([]);
      setFilteredRequest([]);
    }
  }, [listData, golda, tahun, searchQuery]);

  const ambilRequest = (uid) => {
    axios({
      method: "get",
      url: API_DONOR_DARAH + "donatur",
      timeout: API_TIMEOUT,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data || [];
          setListData(data);
          // Set default tahun ke tahun sekarang jika belum di-set
          if (!tahun) {
            setTahun(new Date().getFullYear().toString());
          }
          // Set default ke "all" untuk menampilkan semua data
          setGolda("all");
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const getListGolda = async () => {
    var data1 = [];

    try {
      const response = await axios.get(API_DONOR_DARAH + "bloodtypes");
      data1 = response.data.data;

      if (data1.length > 0) {
        setListGolda(data1);
      } else {
        setListGolda([]);
      }
      // berita.gambarKu = berita.gambar.split(',');
      // berita.isiKu = berita.isi.split('##');
    } catch (error) {
      console.error(error);
    }
  };

  const getListDesa = async () => {
    try {
      const response = await axios.get(API_DONOR_DARAH + "desa");
      if (response.data?.data) {
        setListDesa(response.data.data);
      } else {
        setListDesa([]);
      }
    } catch (error) {
      console.error(error);
      setListDesa([]);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nama.trim()) newErrors.nama = "Nama wajib diisi";
    if (!formData.bloodTypes)
      newErrors.bloodTypes = "Golongan darah wajib dipilih";
    if (!formData.noHp.trim()) newErrors.noHp = "Nomor HP wajib diisi";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openAddForm = () => {
    setIsEdit(false);
    setSelectedId(null);
    setFormData({ nama: "", bloodTypes: "", desa: "", noHp: "" });
    setErrors({});
    setModalFormOpen(true);
  };

  const openEditForm = (item) => {
    setIsEdit(true);
    setSelectedId(item.id);
    setFormData({
      nama: item.nama || "",
      bloodTypes: item.bloodTypes || "",
      desa: item.desa || "",
      noHp: item.noHp || "",
    });
    setErrors({});
    setModalFormOpen(true);
  };

  const closeForm = () => {
    setModalFormOpen(false);
    setSaving(false);
    setErrors({});
  };

  const handleSaveDonor = async (e) => {
    if (e) e.preventDefault();
    if (!validateForm()) return;
    setSaving(true);

    const payload = {
      nama: formData.nama,
      bloodTypes: formData.bloodTypes,
      desa: formData.desa || null,
      noHp: formData.noHp,
    };

    try {
      if (isEdit && selectedId) {
        const res = await axios.put(
          `${API_DONOR_DARAH}donatur/${selectedId}`,
          payload,
          {
            timeout: API_TIMEOUT,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (res.data?.success) {
          swal(
            "Berhasil",
            res.data.message || "Data pendonor diperbarui",
            "success"
          );
          ambilRequest(currentUser.uid);
          closeForm();
        } else {
          swal("Error", res.data?.message || "Gagal memperbarui data", "error");
        }
      } else {
        const res = await axios.post(`${API_DONOR_DARAH}donatur`, payload, {
          timeout: API_TIMEOUT,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (res.data?.success) {
          swal(
            "Berhasil",
            res.data.message || "Data pendonor disimpan",
            "success"
          );
          ambilRequest(currentUser.uid);
          closeForm();
        } else {
          swal("Error", res.data?.message || "Gagal menyimpan data", "error");
        }
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat menyimpan data";
      swal("Error", msg, "error");
    } finally {
      setSaving(false);
    }
  };

  const handleSubmit = async (event) => {
    if (!jumlah || !tanggal) {
      swal("Info", "Semua data harus diisi", "info");
      setSaveLoading(false);
      return;
    }

    const tgl = new Date(tanggal);
    const year = tgl.getFullYear();
    const month = String(tgl.getMonth() + 1).padStart(2, "0");
    const day = String(tgl.getDate()).padStart(2, "0");
    const date_string = `${year}-${month}-${day}`;

    const data = {
      jumlahKantung: jumlah,
      tanggalRealisasi: date_string,
      id: id_unit,
    };

    await axios({
      method: "patch",
      url: API_DONOR_DARAH + "donationrespon/" + id_unit,
      timeout: API_TIMEOUT,
      credentials: "include",
      data: data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR

          swal("Failed", "ada kesalahan pada server", "error");
        } else {
          //BERHASIL

          swal(
            "Success",
            "Anda berhasil mencatat pelaksanaan donor. Terima kasih atas donasinya",
            "success"
          );
          ambilRequest(currentUser.uid);
          onModalClose();
          setSaveLoading(false);
        }
      })
      .catch((error) => {
        // ERROR
        swal("Failed", "Ada kesalahan pada server", "error");
      });

    setSaveLoading(false);
  };

  const onModalClose = () => {
    setId_Unit("");
    setTanggal("");

    setJumlah(0);
    setModalOpen2(false);
  };

  const handleSimpan = () => {
    setSaveLoading(true);
    handleSubmit();
  };

  const handleWhatsAppClick = (item) => {
    setSelectedDonor(item);
    setModalWhatsAppOpen(true);
  };

  const confirmWhatsApp = () => {
    if (selectedDonor && selectedDonor.noHp) {
      // Format nomor HP (hilangkan karakter non-digit, pastikan dimulai dengan 62 untuk Indonesia)
      let phoneNumber = selectedDonor.noHp.replace(/\D/g, "");
      // Jika nomor dimulai dengan 0, ganti dengan 62
      if (phoneNumber.startsWith("0")) {
        phoneNumber = "62" + phoneNumber.substring(1);
      } else if (!phoneNumber.startsWith("62")) {
        phoneNumber = "62" + phoneNumber;
      }
      // Buka WhatsApp dengan nomor tersebut
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank");
      setModalWhatsAppOpen(false);
      // Setelah WhatsApp dibuka, buka modal Pelaksanaan Donor
      // Simpan data donor untuk modal Pelaksanaan Donor
      setId_Unit(selectedDonor.id);
      setModalOpen2(true);
      setSelectedDonor(null);
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <CardTitle tag="h4">
                  Daftar Donatur <Badge color="warning">Kab. Rote Ndao</Badge>
                </CardTitle>
                <div
                  style={{
                    display: "flex",
                    gap: 15,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Button color="primary" size="sm" onClick={openAddForm}>
                    Tambah Donor
                  </Button>
                  <FormGroup style={{ marginBottom: 0, minWidth: "200px" }}>
                    <label>Cari (Nama/No. HP)</label>
                    <Input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Cari nama atau nomor HP..."
                      style={{ minWidth: "200px" }}
                    />
                  </FormGroup>
                  <FormGroup style={{ marginBottom: 0 }}>
                    <label>Golongan Darah</label>
                    <Input
                      type="select"
                      value={golda}
                      onChange={(e) => setGolda(e.target.value)}
                      required
                    >
                      <option value={"all"}>Semua</option>
                      {listGolda.map((item) => (
                        <option
                          key={item.golonganDarah}
                          value={item.golonganDarah}
                        >
                          {item.golonganDarah}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup style={{ marginBottom: 0 }}>
                    <label>Tahun</label>
                    <Input
                      type="select"
                      value={tahun}
                      onChange={(e) => setTahun(e.target.value)}
                    >
                      {(() => {
                        const currentYear = new Date().getFullYear();
                        const years = [];
                        for (let i = currentYear; i >= currentYear - 2; i--) {
                          years.push(
                            <option key={i} value={i.toString()}>
                              {i}
                            </option>
                          );
                        }
                        return years;
                      })()}
                    </Input>
                  </FormGroup>
                </div>
              </CardHeader>

              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Nama Donatur</th>
                      <th>Golongan Darah</th>
                      <th>Asal Desa</th>

                      <th>Nomor Telpon</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabelRequest &&
                      tabelRequest.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>{index + 1}</td>
                          <td>{item.nama}</td>
                          <td>{item.bloodTypes}</td>

                          <td>{item.desa}</td>

                          <td>{item.noHp}</td>
                          <td>
                            <div style={{ display: "flex", gap: 8 }}>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => openEditForm(item)}
                              >
                                Edit
                              </Button>
                              <Button
                                color={14 === 14 ? "success" : "primary"}
                                size="sm"
                                onClick={() => handleWhatsAppClick(item)}
                              >
                                <img
                                  style={{ width: 20, marginRight: 5 }}
                                  src={Phone}
                                  alt="phone"
                                />
                                Telpon
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Form Donor */}
        <Modal
          size="md"
          isOpen={modalFormOpen}
          toggle={closeForm}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={closeForm}>
            {isEdit ? "Edit Data Donor" : "Tambah Data Donor"}
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSaveDonor}>
              <FormGroup>
                <Label>Nama</Label>
                <Input
                  value={formData.nama}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, nama: e.target.value }))
                  }
                  invalid={!!errors.nama}
                  placeholder="Nama pendonor"
                />
                {errors.nama && (
                  <div style={{ color: "#e63946", fontSize: "0.85rem" }}>
                    {errors.nama}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <Label>Golongan Darah</Label>
                <Input
                  type="select"
                  value={formData.bloodTypes}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      bloodTypes: e.target.value,
                    }))
                  }
                  invalid={!!errors.bloodTypes}
                >
                  <option value="">Pilih golongan darah</option>
                  {listGolda.map((item) => (
                    <option key={item.golonganDarah} value={item.golonganDarah}>
                      {item.golonganDarah}
                    </option>
                  ))}
                </Input>
                {errors.bloodTypes && (
                  <div style={{ color: "#e63946", fontSize: "0.85rem" }}>
                    {errors.bloodTypes}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <Label>Desa</Label>
                <Input
                  type="select"
                  value={formData.desa}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, desa: e.target.value }))
                  }
                >
                  <option value="">Pilih desa (opsional)</option>
                  {listDesa.map((item) => (
                    <option key={item.desa} value={item.desa}>
                      {item.desa}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Nomor HP</Label>
                <Input
                  type="tel"
                  value={formData.noHp}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, noHp: e.target.value }))
                  }
                  invalid={!!errors.noHp}
                  placeholder="Contoh: 08123456789"
                />
                {errors.noHp && (
                  <div style={{ color: "#e63946", fontSize: "0.85rem" }}>
                    {errors.noHp}
                  </div>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <Button
              className="btn-rounded"
              size="sm"
              color="secondary-red"
              onClick={closeForm}
              disabled={saving}
            >
              Cancel
            </Button>
            <div style={{ marginLeft: 5 }}></div>
            <Button
              className="btn-rounded"
              color="primary"
              size="sm"
              onClick={handleSaveDonor}
              disabled={saving}
            >
              {saving ? "Menyimpan..." : "Simpan"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          size="md"
          isOpen={modalOpen2}
          toggle={() => setModalOpen2(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalOpen2(false)}>
            <div>
              <div className="headline-2">{"Pelaksanaan Pendonor"}</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label md={3} className="text-md-right" for="markdown-editor">
                Tanggal
              </Label>
              <Col md={9}>
                <Input
                  value={tanggal}
                  onChange={(e) => setTanggal(e.target.value)}
                  style={{ color: "black" }}
                  type="date"
                />
              </Col>
            </FormGroup>

            <div>
              <FormGroup row>
                <Label lg="3" className="text-md-right mt-3">
                  Jumlah Kantung
                </Label>
                <Col lg="9">
                  <div>
                    <label></label>
                    <Input
                      style={{ color: "black" }}
                      type="number"
                      name="liga"
                      value={jumlah}
                      onChange={(event) => {
                        setJumlah(event.target.value);
                      }}
                    />
                  </div>
                </Col>
              </FormGroup>
            </div>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={() => {
                  onModalClose();
                  setModalOpen2(false);
                }}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              {!saveLoading ? (
                <Button
                  className="btn-rounded"
                  color="primary"
                  size="sm"
                  onClick={handleSimpan}
                >
                  {" "}
                  {"Simpan"}
                </Button>
              ) : (
                <Button className="btn-rounded" size="sm" disabled>
                  {" "}
                  {"Upload ..."}
                </Button>
              )}
            </div>
          </ModalFooter>
        </Modal>

        {/* Modal Konfirmasi WhatsApp */}
        <Modal
          isOpen={modalWhatsAppOpen}
          toggle={() => {
            setModalWhatsAppOpen(false);
            setSelectedDonor(null);
          }}
        >
          <ModalHeader
            toggle={() => {
              setModalWhatsAppOpen(false);
              setSelectedDonor(null);
            }}
          >
            Konfirmasi WhatsApp
          </ModalHeader>
          <ModalBody>
            {selectedDonor && (
              <div>
                <p>
                  Apakah Anda yakin ingin menghubungi{" "}
                  <strong>{selectedDonor.nama}</strong> melalui WhatsApp?
                </p>
                <p>
                  <strong>Nomor HP:</strong> {selectedDonor.noHp}
                </p>
                <p style={{ fontSize: "0.9rem", color: "#666", marginTop: 10 }}>
                  Setelah membuka WhatsApp, Anda akan diarahkan ke form
                  "Pelaksanaan Donor" untuk mencatat pelaksanaan donor.
                </p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setModalWhatsAppOpen(false);
                setSelectedDonor(null);
              }}
            >
              Batal
            </Button>
            <Button color="success" onClick={confirmWhatsApp}>
              Buka WhatsApp
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default ListDonatur;
